import React from "react";
import SplitPane from "react-split-pane";
import "./splitComponent.scss";
import { KEY } from "../../constants/common.const";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import rolesConst from "../../routers/roles/roles.const";
import { useLocation } from "react-router-dom";

const SplitComponent = ({
  split = "vertical",
  minSize = 0,
  defaultSize = "50%",
  maxSize,
  onChange,
  children,
  style = {
    height:"calc(100vh - 130px)"
  },
  paneStyle = {},
  onDragFinished = () => {}
}) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const location = useLocation();

  const { collapsed } = useSelector((state) => state.sideBar);
  const { roles } = useSelector((state) => state.auth);
  const urlParams = new URLSearchParams(window.location.search);
  const queryIsEndUSer = urlParams.get("isEndUser");

  const isEndUser =
    [rolesConst.CUSTOMER, rolesConst.SPECIAL_CUSTOMER].includes(roles) ||
    location.pathname === "/EndUser" ||
    queryIsEndUSer == "true";
  const className =
    isDesktopOrLaptop && !isEndUser
      ? collapsed
        ? "split-component-no-collapsed"
        : "split-component-collapsed"
      : "";
  return (
    <div
      className={className}
      style={{ height: "100%", width: "100%", ...style }}
    >
      <SplitPane
       onDragFinished={onDragFinished}
        split={split}
        minSize={minSize}
        defaultSize={defaultSize}
        maxSize={maxSize}
        onChange={onChange}
        allowResize={true}
        style={style}
        paneStyle={{ ...paneStyle }}
        resizerClassName="Resizer"
      >
        {children}
      </SplitPane>
    </div>
  );
};
export default SplitComponent;
